import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "\n      d-flex\n      flex-column flex-column-fluid\n      bgi-position-y-bottom\n      position-x-center\n      bgi-no-repeat bgi-size-contain bgi-attachment-fixed\n    ",
  style: {"background-image":"url('media/illustrations/progress-hd.png')","background-color":"#597dfe !important"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/logos/logo.png",
    class: "h-45px"
  })
], -1)
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row g-3" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_8 = { class: "mb-10 text-center" }
const _hoisted_9 = { class: "text-dark mb-3" }
const _hoisted_10 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-light-primary fw-bolder w-100 mb-10"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/svg/brand-logos/google-icon.svg",
    class: "h-20px me-3"
  }),
  /*#__PURE__*/_createTextVNode(" Sign in with Google ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center mb-10" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }),
  /*#__PURE__*/_createVNode("span", { class: "fw-bold text-gray-400 fs-7 mx-2" }, "OR"),
  /*#__PURE__*/_createVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" })
], -1)
const _hoisted_14 = { class: "fv-row mb-7" }
const _hoisted_15 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row fv-row mb-7" }
const _hoisted_19 = { class: "col-xl-6" }
const _hoisted_20 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "col-xl-6" }
const _hoisted_24 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = {
  class: "row fv-row mb-7",
  "data-kt-password-meter": "true"
}
const _hoisted_28 = { class: "col-xl-6" }
const _hoisted_29 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_30 = { class: "position-relative mb-3" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "col-xl-6" }
const _hoisted_34 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_38 = { class: "col-xl-6" }
const _hoisted_39 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_40 = {
  key: 0,
  class: `flag-icon flag-icon-AZ`
}
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "fv-row mt-9 mb-10" }
const _hoisted_44 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_45 = {
  class: "\n                        form-check-label\n                        fw-bold\n                        text-gray-700\n                        fs-6\n                        d-inline-block\n                      ",
  style: {"max-width":"510px"}
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" . ")
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_51 = { class: "indicator-label" }
const _hoisted_52 = { class: "indicator-progress" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_54 = {
  class: "w-175px",
  style: {"display":"flex","align-content":"space-between","margin-left":"38%"}
}
const _hoisted_55 = { class: "menu-item" }
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg"
  })
], -1)
const _hoisted_57 = { class: "menu-item" }
const _hoisted_58 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/spain.svg"
  })
], -1)
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_61 = { class: "mb-10 text-center" }
const _hoisted_62 = { class: "alert-heading" }
const _hoisted_63 = { class: "container" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "tutorial text-center my-5 ratio ratio-16x9" }, [
  /*#__PURE__*/_createVNode("iframe", {
    src: "https://www.youtube.com/embed/In7S2NpAYBI?controls=0&rel=0",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1)
const _hoisted_65 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_66 = { class: "accordion-item" }
const _hoisted_67 = {
  class: "accordion-header",
  id: "headingOne"
}
const _hoisted_68 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseOne",
  "aria-expanded": "true",
  "aria-controls": "collapseOne"
}
const _hoisted_69 = {
  id: "collapseOne",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingOne",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_70 = { class: "accordion-body" }
const _hoisted_71 = { href: "https://www.futuregg.com/por-que-el-implementar-okr-es-gratis-en-futuregg/" }
const _hoisted_72 = { class: "accordion-item" }
const _hoisted_73 = {
  class: "accordion-header",
  id: "headingTwo"
}
const _hoisted_74 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseTwo",
  "aria-expanded": "false",
  "aria-controls": "collapseTwo"
}
const _hoisted_75 = {
  id: "collapseTwo",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingTwo",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_76 = { class: "accordion-body" }
const _hoisted_77 = { class: "accordion-item" }
const _hoisted_78 = {
  class: "accordion-header",
  id: "headingThree"
}
const _hoisted_79 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseThree",
  "aria-expanded": "false",
  "aria-controls": "collapseThree"
}
const _hoisted_80 = {
  id: "collapseThree",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingThree",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_81 = { class: "accordion-body" }
const _hoisted_82 = { class: "accordion-item" }
const _hoisted_83 = {
  class: "accordion-header",
  id: "headingFour"
}
const _hoisted_84 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseFour",
  "aria-expanded": "false",
  "aria-controls": "collapseThree"
}
const _hoisted_85 = {
  id: "collapseFour",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingFour",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_86 = { class: "accordion-body" }
const _hoisted_87 = { class: "accordion-item" }
const _hoisted_88 = {
  class: "accordion-header",
  id: "headingFive"
}
const _hoisted_89 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseFive",
  "aria-expanded": "false",
  "aria-controls": "collapseThree"
}
const _hoisted_90 = {
  id: "collapseFive",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingFive",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_91 = { class: "accordion-body" }
const _hoisted_92 = { class: "accordion-item" }
const _hoisted_93 = {
  class: "accordion-header",
  id: "headingSix"
}
const _hoisted_94 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseSix",
  "aria-expanded": "false",
  "aria-controls": "collapseThree"
}
const _hoisted_95 = {
  id: "collapseSix",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingSix",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_96 = { class: "accordion-body" }
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center fw-bold fs-6" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "https://www.futuregg.com/egg-okr/",
      class: "text-muted text-hover-primary px-2"
    }, "About")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Form, {
                class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
                novalidate: "novalidate",
                onSubmit: _ctx.onSubmitRegister,
                id: "kt_login_signup_form",
                "validation-schema": _ctx.registration
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("h1", _hoisted_9, _toDisplayString(_ctx.translate("createAccount")), 1),
                    _createVNode("div", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.translate("signInSuggestion")) + " ", 1),
                      _createVNode(_component_router_link, {
                        to: "/sign-in",
                        class: "link-primary fw-bolder"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.translate("signIn")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _hoisted_12,
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("label", _hoisted_15, _toDisplayString(_ctx.translate("email")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid",
                      type: "email",
                      placeholder: "",
                      name: "email",
                      autocomplete: "off"
                    }),
                    _createVNode("div", _hoisted_16, [
                      _createVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "email" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      _createVNode("label", _hoisted_20, _toDisplayString(_ctx.translate("name")), 1),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg form-control-solid",
                        type: "text",
                        placeholder: "",
                        name: "name",
                        autocomplete: "off"
                      }),
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, [
                          _createVNode(_component_ErrorMessage, { name: "name" })
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("label", _hoisted_24, _toDisplayString(_ctx.translate("lastName")), 1),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg form-control-solid",
                        type: "text",
                        placeholder: "",
                        name: "surname",
                        autocomplete: "off"
                      }),
                      _createVNode("div", _hoisted_25, [
                        _createVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "surname" })
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("label", _hoisted_29, _toDisplayString(_ctx.translate("password")), 1),
                      _createVNode("div", _hoisted_30, [
                        _createVNode(_component_Field, {
                          class: "form-control form-control-lg form-control-solid",
                          type: "password",
                          placeholder: "",
                          name: "password",
                          autocomplete: "off"
                        }),
                        _createVNode("div", _hoisted_31, [
                          _createVNode("div", _hoisted_32, [
                            _createVNode(_component_ErrorMessage, { name: "password" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_33, [
                      _createVNode("label", _hoisted_34, _toDisplayString(_ctx.translate("passwordConfirm")), 1),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg form-control-solid",
                        type: "password",
                        placeholder: "",
                        name: "cpassword",
                        autocomplete: "off"
                      }),
                      _createVNode("div", _hoisted_35, [
                        _createVNode("div", _hoisted_36, [
                          _createVNode(_component_ErrorMessage, { name: "cpassword" })
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("label", _hoisted_39, _toDisplayString(_ctx.translate("phone")), 1),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg form-control-solid",
                        type: "phone",
                        placeholder: "",
                        name: "phone",
                        autocomplete: "off"
                      }),
                      (_ctx.countryCode)
                        ? (_openBlock(), _createBlock("span", _hoisted_40))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_41, [
                        _createVNode("div", _hoisted_42, [
                          _createVNode(_component_ErrorMessage, { name: "phone" })
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_43, [
                    _createVNode("label", _hoisted_44, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        type: "checkbox",
                        name: "toc",
                        value: "1"
                      }),
                      _createVNode("span", _hoisted_45, [
                        _createTextVNode(_toDisplayString(_ctx.translate("acceptedOur")) + " ", 1),
                        _createVNode(_component_router_link, {
                          to: "/terms",
                          class: "ms-1 link-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("termAndCondition")), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_46
                      ])
                    ]),
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, [
                        _createVNode(_component_ErrorMessage, { name: "toc" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_49, [
                    _createVNode("button", _hoisted_50, [
                      _createVNode("span", _hoisted_51, _toDisplayString(_ctx.translate("send")), 1),
                      _createVNode("span", _hoisted_52, [
                        _createTextVNode(_toDisplayString(_ctx.translate("pleaseWait")) + " ", 1),
                        _hoisted_53
                      ])
                    ], 512)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"]),
              _createVNode("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, [
                  _createVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('en'))),
                    href: "#",
                    class: ["menu-link d-flex", { active: _ctx.currentLanguage('en') }]
                  }, [
                    _hoisted_56
                  ], 2)
                ]),
                _createVNode("div", _hoisted_57, [
                  _createVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('es'))),
                    href: "#",
                    class: ["menu-link d-flex", { active: _ctx.currentLanguage('es') }]
                  }, [
                    _hoisted_58
                  ], 2)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, [
                _createVNode("h5", _hoisted_62, _toDisplayString(_ctx.translate("okrSoftware")), 1)
              ]),
              _createVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode("div", _hoisted_65, [
                  _createVNode("div", _hoisted_66, [
                    _createVNode("h2", _hoisted_67, [
                      _createVNode("button", _hoisted_68, [
                        _createVNode("strong", null, _toDisplayString(_ctx.translate("freeSoftwareTitle")), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_69, [
                      _createVNode("div", _hoisted_70, [
                        _createTextVNode(_toDisplayString(_ctx.translate("freeSoftwareDescrp")) + " ", 1),
                        _createVNode("a", _hoisted_71, _toDisplayString(_ctx.translate("freeSoftwareWhy")), 1)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_72, [
                    _createVNode("h2", _hoisted_73, [
                      _createVNode("button", _hoisted_74, [
                        _createVNode("strong", null, _toDisplayString(_ctx.translate("planningTitle")), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_75, [
                      _createVNode("div", _hoisted_76, _toDisplayString(_ctx.translate("planningDescrip")), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_77, [
                    _createVNode("h2", _hoisted_78, [
                      _createVNode("button", _hoisted_79, [
                        _createVNode("strong", null, _toDisplayString(_ctx.translate("executeTitle")), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_80, [
                      _createVNode("div", _hoisted_81, _toDisplayString(_ctx.translate("executeDescrip")), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_82, [
                    _createVNode("h2", _hoisted_83, [
                      _createVNode("button", _hoisted_84, [
                        _createVNode("strong", null, _toDisplayString(_ctx.translate("updateTitle")), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_85, [
                      _createVNode("div", _hoisted_86, _toDisplayString(_ctx.translate("updateDescrip")), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_87, [
                    _createVNode("h2", _hoisted_88, [
                      _createVNode("button", _hoisted_89, [
                        _createVNode("strong", null, _toDisplayString(_ctx.translate("learnTitle")), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_90, [
                      _createVNode("div", _hoisted_91, _toDisplayString(_ctx.translate("learnDescrip")), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_92, [
                    _createVNode("h2", _hoisted_93, [
                      _createVNode("button", _hoisted_94, [
                        _createVNode("strong", null, _toDisplayString(_ctx.translate("shareTitle")), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_95, [
                      _createVNode("div", _hoisted_96, _toDisplayString(_ctx.translate("shareDescrip")), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_97
  ]))
}